export const BUSINESS_REQUIRED_DOCUMENT_IMAGES = [
	{
		id: 494,
		name: 'تفریحی و ورزشی',
		children: [
			{
				name: 'باشگاه ها',
				items: ['مدرک مربی‌گری', 'پروانه کسب'],
			},
			{
				name: 'تئاتر هنر',
				items: ['مجوز وزارت ارشاد', 'عکس پوستر'],
			},
			{
				name: 'استخر',
				items: ['برگه مناقصه', 'پروانه کسب'],
			},
			{
				name: 'ورزش های هوایی',
				items: ['مجوز خلبانی از فدراسیون ورزش هوایی'],
			},
			{
				name: 'شهربازی',
				items: [
					'جواز کسب (گر جوازکسب به نام شخص دیگری باشد برای واریزی‌ها گرفتن رضایت‌نامه از آن شخص الزامی می‌باشد)',
				],
			},
			{
				name: 'بازی های گروهی',
				items: ['مجوز های لازمه برای بازی‌های گروهی (جواز کسب)'],
			},
			{
				name: 'اتاق فرار، ایکس بادی، تی آر ایکس، پیلاتس، یوگا',
				items: ['مجوزی نیاز نیست...'],
			},
		],
	},
	{
		id: 495,
		name: 'آموزش',
		children: [
			{
				name: 'آموزش‌های حضوری و آنلاین',
				items: [
					'پروانه تاسیس (اگر پروانه تاسیس به نام شخص دیگری باشد، گرفتن رضایت نامه از آن شخص الزامی می‌باشد)',
				],
			},
		],
	},
	{
		id: 491,
		name: 'رستوران و کافی شاپ',
		children: [
			{
				name: 'فست فود-کافه-بوفه و .....',
				items: ['سردر', 'جواز کسب', 'قرار داد ملک تجاری'],
			},
		],
	},
	{
		id: 493,
		name: 'سلامتی و پزشکی',
		children: [
			{
				name: 'ژل و بوتاکس، مراکز لیزر، جوانسازی و اسلیمینگ، مراکز لاغری، مراکز دندانپزشکی',
				items: [
					'پروانه بهره برداری',
					'پروانه مطب',
					'کارت نظام پزشکی (اگر مجوز به نام شخص دیگری باشد گرفتن رضایت‌نامه از آن شخص الزامی می‌باشد )',
				],
			},
			{
				name: 'ماساژ و اسپا',
				items: ['مدرک فنی حرفه ای', 'پروانه کسب', 'مدرک معتبر ماساژ'],
			},
			{
				name: 'مراکز مشاوره',
				items: ['کارت سازمان نظام روانشناسی', 'پروانه تاسیس'],
			},
			{
				name: 'پاکسازی - میکرودرم',
				items: [
					'مدرک فنی حرفه‌ای',
					'پروانه مطب',
					'پروانه بهره‌برداری',
					'کارت نظام پزشکی',
					'سرتیفیکیت',
				],
			},
		],
	},
	{
		id: 492,
		name: 'زیبایی و آرایشی',
		children: [
			{
				name: 'سالن‌های زیبایی',
				items: [
					'مدرک فنی حرفه ای',
					'تابلو سالن',
					'جواز کسب (اگر جوازکسب به نام شخص دیگری باشد، گرفتن رضایت نامه از آن شخص الزامی می‌باشد)',
				],
			},
		],
	},
	{
		id: 838,
		name: 'تور و سفر',
		children: [
			{
				name: 'تور',
				items: [
					'استعلام مجوز آژانس از سایت گردشگری',
					'کارت تورلیدر دارای تاریخ',
				],
			},
		],
	},
];
